<div class="rcs-rich-card-builder">
  <div class="card">
    <div class="card-header">RCS Standalone Rich Card</div>
    
    <div class="form-group">
      <label for="cardTitle">Card Title</label>
      <div class="input-group">
        <input
          #titleInput
          type="text"
          id="cardTitle"
          [(ngModel)]="richCard.title"
          (ngModelChange)="onFieldChange()"
          (blur)="validateField('title', richCard.title)"
          (click)="rememberSelection($event, 'title')"
          (keyup)="rememberSelection($event, 'title')"
          (mouseup)="rememberSelection($event, 'title')"
          [class.error]="fieldErrors['title']"
          placeholder="Enter card title">
        <div class="input-group-append">
          <button
            mdbTooltip="Insert Wildcard"
            placement="top"
            class="input-group-text insert-wilcard"
            (click)="_formGroupInsertWildcard.reset(); openWildcard('title', titleInput)">
            <span class="insert-wilcard-span">W</span>
          </button>
        </div>
      </div>
      <small class="error-text" *ngIf="fieldErrors['title']">{{ fieldErrors['title'] }}</small>
    </div>

    <div class="form-group">
      <label for="cardDescription">Description</label>
      <div class="input-group">
        <textarea
          #descriptionInput
          id="cardDescription"
          [(ngModel)]="richCard.description"
          (ngModelChange)="onFieldChange()"
          (blur)="validateField('description', richCard.description)"
          (click)="rememberSelection($event, 'description')"
          (keyup)="rememberSelection($event, 'description')"
          (mouseup)="rememberSelection($event, 'description')"
          [class.error]="fieldErrors['description']"
          placeholder="Enter card description"
          rows="4">
        </textarea>
        <div class="input-group-append">
          <button
            mdbTooltip="Insert Wildcard"
            placement="top"
            class="input-group-text insert-wilcard"
            (click)="_formGroupInsertWildcard.reset(); openWildcard('description', descriptionInput)">
            <span class="insert-wilcard-span">W</span>
          </button>
        </div>
      </div>
      <small class="error-text" *ngIf="fieldErrors['description']">{{ fieldErrors['description'] }}</small>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label for="orientation">Orientation</label>
        <select
          id="orientation"
          [(ngModel)]="richCard.orientation"
          (ngModelChange)="onFieldChange()">
          <option value="VERTICAL">Vertical</option>
          <option value="HORIZONTAL">Horizontal</option>
        </select>
      </div>

      <div class="form-group">
        <label for="thumbnailAlignment">Thumbnail Alignment</label>
        <select
          id="thumbnailAlignment"
          [(ngModel)]="richCard.thumbnailAlignment"
          (ngModelChange)="onFieldChange()">
          <option value="LEFT">Left</option>
          <option value="RIGHT">Right</option>          
        </select>
      </div>
    </div>

    <div class="form-group">
      <label for="mediaUrl">Media URL</label>
      <div class="input-with-button">
        <input
          type="url"
          id="mediaUrl"
          [ngModel]="richCard.media?.url"
          (ngModelChange)="richCard.media!.url = $event; onMediaUrlChange()"
          (blur)="validateField('mediaUrl', richCard.media?.url)"
          [class.error]="fieldErrors['mediaUrl']"
          placeholder="https://example.com/image.jpg">
        <button type="button" class="btn-media-server" (click)="openMediaServerModal()">Load from Media Server</button>
      </div>
      <small class="error-text" *ngIf="fieldErrors['mediaUrl']">{{ fieldErrors['mediaUrl'] }}</small>
      <!-- Media preview -->
      <div class="media-preview" *ngIf="richCard.media?.url">
        <img [src]="richCard.media.url" alt="Media preview" (error)="onMediaLoadError()">
      </div>
    </div>

    <div class="form-group">
      <label for="mediaHeight">Media Height</label>
      <select
        id="mediaHeight"
        [ngModel]="richCard.media?.height"
        (ngModelChange)="richCard.media!.height = $event; onFieldChange()">
        <option value="SHORT">Short</option>
        <option value="MEDIUM">Medium</option>
        <option value="TALL">Tall</option>
      </select>
    </div>

    <div class="form-group checkbox-group">
      <label class="checkbox-label">
        <input
          type="checkbox"
          [(ngModel)]="hasThumbnail"
          (ngModelChange)="onThumbnailToggle()"
          class="checkbox-input">
        <span class="checkbox-text">Include Thumbnail</span>
      </label>
    </div>

    <div *ngIf="hasThumbnail">
      <div class="form-group">
        <label for="thumbnailUrl">Thumbnail URL</label>
        <div class="input-with-button">
          <input
            type="url"
            id="thumbnailUrl"
            [ngModel]="richCard.thumbnail?.url"
            (ngModelChange)="richCard.thumbnail!.url = $event; onThumbnailUrlChange()"
            (blur)="validateField('thumbnailUrl', richCard.thumbnail?.url)"
            [class.error]="fieldErrors['thumbnailUrl']"
            placeholder="https://example.com/thumbnail.jpg">
          <button type="button" class="btn-media-server" (click)="openMediaServerModal('thumbnail')">Load from Media Server</button>
        </div>
        <small class="error-text" *ngIf="fieldErrors['thumbnailUrl']">{{ fieldErrors['thumbnailUrl'] }}</small>
        <div class="media-preview" *ngIf="richCard.thumbnail?.url">
          <img [src]="richCard.thumbnail.url" alt="Thumbnail preview" (error)="onMediaLoadError('thumbnailUrl')">
        </div>
      </div>

      <div class="form-group">
        <label for="thumbnailHeight">Thumbnail Height</label>
        <select
          id="thumbnailHeight"
          [ngModel]="richCard.thumbnail?.height"
          (ngModelChange)="richCard.thumbnail!.height = $event; onFieldChange()">
          <option value="SHORT">Short</option>
          <option value="MEDIUM">Medium</option>
          <option value="TALL">Tall</option>
        </select>
      </div>
    </div>

    <div class="suggestions-section">
      <div class="section-header">
        <h3>Message Actions</h3>
        <small>Add interactive buttons to your card</small>
      </div>

      <div class="suggestions-list" *ngIf="richCard.suggestions && richCard.suggestions.length > 0">
        <div class="suggestion-item" *ngFor="let suggestion of richCard.suggestions; let i = index">
          <!-- Display mode -->
          <div *ngIf="editingIndex !== i" class="suggestion-content">
            <div class="suggestion-details">
              <strong>{{ suggestion.displayText }}</strong>
              <span *ngIf="suggestion.url" class="action-info">
                URL:
                <a
                  [href]="suggestion.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="action-url-link"
                  [title]="suggestion.url">{{ suggestion.url }}</a>
              </span>
              <span *ngIf="suggestion.phone" class="action-info">Phone: {{ suggestion.phone }}</span>
            </div>
            <div class="suggestion-actions">
              <button class="btn-edit" (click)="editSuggestion(i)">Edit</button>
              <button class="btn-remove" (click)="removeSuggestion(i)">Remove</button>
            </div>
          </div>
          
          <!-- Edit mode -->
          <div *ngIf="editingIndex === i" class="suggestion-edit-form">
            <div class="form-group">
              <label>Action Type</label>
              <select [(ngModel)]="editingSuggestion.type" (ngModelChange)="onEditingSuggestionTypeChange()">
                <option [ngValue]="SuggestionType.REPLY">Reply</option>
                <option [ngValue]="SuggestionType.OPEN_URL">Open URL</option>
                <option [ngValue]="SuggestionType.DIAL_PHONE">Dial Phone</option>
                <option [ngValue]="SuggestionType.VIEW_LOCATION">View Location</option>
                <option [ngValue]="SuggestionType.CALENDAR_EVENT">Calendar Event</option>
              </select>
            </div>
            
            <div class="form-group">
              <label>Display Text</label>
              <input
                type="text"
                maxlength="25"
                [(ngModel)]="editingSuggestion.displayText"
                [class.error]="editingSuggestionErrors['displayText']"
                placeholder="Button text (max 25 chars)">
              <small class="char-count">{{ editingSuggestion.displayText?.length || 0 }}/25</small>
              <small class="error-text" *ngIf="editingSuggestionErrors['displayText']">{{ editingSuggestionErrors['displayText'] }}</small>
            </div>

            <!-- Open URL fields -->
            <div class="form-group" *ngIf="editingSuggestion.type === SuggestionType.OPEN_URL">
              <label>URL</label>
              <input
                type="url"
                [(ngModel)]="editingSuggestion.url"
                [class.error]="editingSuggestionErrors['url']"
                placeholder="https://example.com">
              <small class="error-text" *ngIf="editingSuggestionErrors['url']">{{ editingSuggestionErrors['url'] }}</small>
            </div>

            <!-- Dial Phone fields -->
            <div class="form-group" *ngIf="editingSuggestion.type === SuggestionType.DIAL_PHONE">
              <label>Phone Number</label>
              <input
                type="tel"
                [(ngModel)]="editingSuggestion.phone"
                [class.error]="editingSuggestionErrors['phone']"
                placeholder="+441234567890">
              <small class="error-text" *ngIf="editingSuggestionErrors['phone']">{{ editingSuggestionErrors['phone'] }}</small>
            </div>

            <!-- View Location fields -->
            <div *ngIf="editingSuggestion.type === SuggestionType.VIEW_LOCATION">
              <div class="form-group">
                <label>Address (Optional)</label>
                <input
                  type="text"
                  [(ngModel)]="editingSuggestion.address"
                  placeholder="Street address">
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Latitude</label>
                  <input
                    type="number"
                    [(ngModel)]="editingSuggestion.latitude"
                    [class.error]="editingSuggestionErrors['latitude']"
                    placeholder="43.649269"
                    step="any">
                  <small class="error-text" *ngIf="editingSuggestionErrors['latitude']">{{ editingSuggestionErrors['latitude'] }}</small>
                </div>
                <div class="form-group">
                  <label>Longitude</label>
                  <input
                    type="number"
                    [(ngModel)]="editingSuggestion.longitude"
                    [class.error]="editingSuggestionErrors['longitude']"
                    placeholder="-79.378423"
                    step="any">
                  <small class="error-text" *ngIf="editingSuggestionErrors['longitude']">{{ editingSuggestionErrors['longitude'] }}</small>
                </div>
              </div>
            </div>

            <!-- Calendar Event fields -->
            <div *ngIf="editingSuggestion.type === SuggestionType.CALENDAR_EVENT">
              <div class="form-group">
                <label>Meeting Title</label>
                <input
                  type="text"
                  maxlength="100"
                  [(ngModel)]="editingSuggestion.meetingTitle"
                  [class.error]="editingSuggestionErrors['meetingTitle']"
                  placeholder="Test Drive">
                <small class="char-count">{{ editingSuggestion.meetingTitle?.length || 0 }}/100</small>
                <small class="error-text" *ngIf="editingSuggestionErrors['meetingTitle']">{{ editingSuggestionErrors['meetingTitle'] }}</small>
              </div>
              <div class="form-group">
                <label>Meeting Description (Optional)</label>
                <textarea
                  [(ngModel)]="editingSuggestion.meetingDescription"
                  [class.error]="editingSuggestionErrors['meetingDescription']"
                  placeholder="Meeting description"
                  rows="2">
                </textarea>
                <small class="error-text" *ngIf="editingSuggestionErrors['meetingDescription']">{{ editingSuggestionErrors['meetingDescription'] }}</small>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Start Time (ISO 8601)</label>
                  <input
                    type="datetime-local"
                    [(ngModel)]="editingSuggestion.startTime"
                    [class.error]="editingSuggestionErrors['startTime']"
                    placeholder="2025-12-01T09:00:00Z">
                  <small class="error-text" *ngIf="editingSuggestionErrors['startTime']">{{ editingSuggestionErrors['startTime'] }}</small>
                </div>
                <div class="form-group">
                  <label>End Time (ISO 8601)</label>
                  <input
                    type="datetime-local"
                    [(ngModel)]="editingSuggestion.endTime"
                    [class.error]="editingSuggestionErrors['endTime']"
                    placeholder="2025-12-05T17:00:00Z">
                  <small class="error-text" *ngIf="editingSuggestionErrors['endTime']">{{ editingSuggestionErrors['endTime'] }}</small>
                </div>
              </div>
            </div>

            <div class="edit-actions">
              <button class="btn btn-primary btn-sm" (click)="saveEditingSuggestion()">Save</button>
              <button class="btn btn-secondary btn-sm" (click)="cancelEditingSuggestion()">Cancel</button>
            </div>
          </div>
        </div>
      </div>

      <div class="add-suggestion">
        <h4>Add New Action</h4>
        <div class="form-group">
          <label>Action Type</label>
          <select [(ngModel)]="newSuggestion.type" (ngModelChange)="onSuggestionTypeChange()">
            <option [ngValue]="SuggestionType.REPLY">Reply</option>
            <option [ngValue]="SuggestionType.OPEN_URL">Open URL</option>
            <option [ngValue]="SuggestionType.DIAL_PHONE">Dial Phone</option>
            <option [ngValue]="SuggestionType.VIEW_LOCATION">View Location</option>
            <option [ngValue]="SuggestionType.CALENDAR_EVENT">Calendar Event</option>
          </select>
        </div>
        <div class="form-group">
          <label>Display Text</label>
          <input
            type="text"
            maxlength="25"
            [(ngModel)]="newSuggestion.displayText"
            (blur)="validateSuggestionField('displayText', newSuggestion.displayText)"
            [class.error]="suggestionErrors['displayText']"
            placeholder="Button text (max 25 chars)">
          <small class="char-count">{{ newSuggestion.displayText?.length || 0 }}/25</small>
          <small class="error-text" *ngIf="suggestionErrors['displayText']">{{ suggestionErrors['displayText'] }}</small>
        </div>

        <!-- Open URL fields -->
        <div class="form-group" *ngIf="newSuggestion.type === SuggestionType.OPEN_URL">
          <label>URL</label>
          <input
            type="url"
            [(ngModel)]="newSuggestion.url"
            (blur)="validateSuggestionField('url', newSuggestion.url)"
            [class.error]="suggestionErrors['url']"
            placeholder="https://example.com">
          <small class="error-text" *ngIf="suggestionErrors['url']">{{ suggestionErrors['url'] }}</small>
        </div>

        <!-- Dial Phone fields -->
        <div class="form-group" *ngIf="newSuggestion.type === SuggestionType.DIAL_PHONE">
          <label>Phone Number</label>
          <input
            type="tel"
            [(ngModel)]="newSuggestion.phone"
            (blur)="validateSuggestionField('phone', newSuggestion.phone)"
            [class.error]="suggestionErrors['phone']"
            placeholder="+441234567890">
          <small class="error-text" *ngIf="suggestionErrors['phone']">{{ suggestionErrors['phone'] }}</small>
        </div>

        <!-- View Location fields -->
        <div *ngIf="newSuggestion.type === SuggestionType.VIEW_LOCATION">
          <div class="form-group">
            <label>Address (Optional)</label>
            <input
              type="text"
              [(ngModel)]="newSuggestion.address"
              placeholder="Street address">
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Latitude</label>
              <input
                type="number"
                [(ngModel)]="newSuggestion.latitude"
                (blur)="validateSuggestionField('latitude', newSuggestion.latitude)"
                [class.error]="suggestionErrors['latitude']"
                placeholder="43.649269"
                step="any">
              <small class="error-text" *ngIf="suggestionErrors['latitude']">{{ suggestionErrors['latitude'] }}</small>
            </div>
            <div class="form-group">
              <label>Longitude</label>
              <input
                type="number"
                [(ngModel)]="newSuggestion.longitude"
                (blur)="validateSuggestionField('longitude', newSuggestion.longitude)"
                [class.error]="suggestionErrors['longitude']"
                placeholder="-79.378423"
                step="any">
              <small class="error-text" *ngIf="suggestionErrors['longitude']">{{ suggestionErrors['longitude'] }}</small>
            </div>
          </div>
        </div>

        <!-- Calendar Event fields -->
        <div *ngIf="newSuggestion.type === SuggestionType.CALENDAR_EVENT">
          <div class="form-group">
            <label>Meeting Title</label>
            <input
              type="text"
              maxlength="100"
              [(ngModel)]="newSuggestion.meetingTitle"
              (blur)="validateSuggestionField('meetingTitle', newSuggestion.meetingTitle)"
              [class.error]="suggestionErrors['meetingTitle']"
              placeholder="Test Drive">
            <small class="char-count">{{ newSuggestion.meetingTitle?.length || 0 }}/100</small>
            <small class="error-text" *ngIf="suggestionErrors['meetingTitle']">{{ suggestionErrors['meetingTitle'] }}</small>
          </div>
          <div class="form-group">
            <label>Meeting Description (Optional)</label>
            <textarea
              [(ngModel)]="newSuggestion.meetingDescription"
              (blur)="validateSuggestionField('meetingDescription', newSuggestion.meetingDescription)"
              [class.error]="suggestionErrors['meetingDescription']"
              placeholder="Meeting description"
              rows="2">
            </textarea>
            <small class="error-text" *ngIf="suggestionErrors['meetingDescription']">{{ suggestionErrors['meetingDescription'] }}</small>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Start Time (ISO 8601)</label>
              <input
                type="datetime-local"
                [(ngModel)]="newSuggestion.startTime"
                (blur)="validateSuggestionField('startTime', newSuggestion.startTime)"
                [class.error]="suggestionErrors['startTime']"
                placeholder="2025-12-01T09:00:00Z">
              <small class="error-text" *ngIf="suggestionErrors['startTime']">{{ suggestionErrors['startTime'] }}</small>
            </div>
            <div class="form-group">
              <label>End Time (ISO 8601)</label>
              <input
                type="datetime-local"
                [(ngModel)]="newSuggestion.endTime"
                (blur)="validateSuggestionField('endTime', newSuggestion.endTime)"
                [class.error]="suggestionErrors['endTime']"
                placeholder="2025-12-05T17:00:00Z">
              <small class="error-text" *ngIf="suggestionErrors['endTime']">{{ suggestionErrors['endTime'] }}</small>
            </div>
          </div>
        </div>

        <button type="button" class="btn btn-primary" (mousedown)="$event.preventDefault()" (click)="addSuggestion()">Add Action</button>
      </div>
    </div>
    <div class="form-group margin-top-20">
      <label for="fallbackText">Fallback Text</label>
      <div class="input-group">
        <textarea
          #fallbackInput
          id="fallbackText"
          [(ngModel)]="fallbackText"
          (ngModelChange)="onFallbackTextChange()"
          (blur)="validateFallbackText()"
          (click)="rememberSelection($event, 'fallback')"
          (keyup)="rememberSelection($event, 'fallback')"
          (mouseup)="rememberSelection($event, 'fallback')"
          [class.error]="fallbackTextError"
          placeholder="Enter fallback text for non-RCS devices"
          rows="6">
        </textarea>       
      </div>
      <small class="help-text" *ngIf="!fallbackTextError">This text will be sent to devices that don't support RCS.</small>
      <small class="error-text" *ngIf="fallbackTextError">{{ fallbackTextError }}</small>
    </div>

    <div class="form-group">
      <label for="sender">Fallback Sender</label>
      <select
        id="sender"
        [(ngModel)]="selectedSenderId"
        (ngModelChange)="onSenderChange()"
        class="form-control fallback-sender-select"
        required>
        <option value="0" disabled>Select Sender</option>
        <option *ngFor="let sender of _clientInboxSelectListOptions" [ngValue]="sender.value">
          {{sender.label}}
        </option>
      </select>
      <small class="error-text" *ngIf="senderError">{{ senderError }}</small>
    </div>
  </div>
</div>

<div mdbModal #mediaServerModal="mdbModal" class="modal fade right modal-overflow" tabindex="-1" role="dialog"
  aria-labelledby="mediaServerModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeMediaServer()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Select Files From Media Server</h4>
      </div>
      <div class="modal-body">
        <app-media-server *ngIf="_showMediaServer"></app-media-server>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close"
          (click)="closeMediaServer()" mdbWavesEffect>Close</button>
        <button type="button" mdbBtn color="primary" class="relative waves-light" (click)="applyMediaFromServer()"
          mdbWavesEffect>OK!</button>
      </div>
    </div>
  </div>
</div>

<div mdbModal #insertWildcardModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="insertWildcardModal" aria-hidden="true">
  <div class="modal-dialog insert-wilcard-modal" role="document">
    <div class="modal-content rounded-lg">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="insertWildcardModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="createFolderModalLabel">Insert Wildcard</h4>
      </div>
      <form [formGroup]="_formGroupInsertWildcard" (ngSubmit)="insertWildcardModalSubmit()">
        <div class="modal-body">
          <div class="form-group pl-16 pr-16">
            <div class="form-row">
              <div class="col-md-12">
                <label for="listFolders" class="input-label">Folder</label>
                <select class="form-control select-input" id="listFolders" formControlName="listFolders">
                  <option value="0" hidden>Select Folder</option>
                  <option *ngFor="let folder of _listFolderSelectListOptions" [ngValue]="folder.value">
                    {{folder.label}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <label for="lists" class="input-label">List</label>
                <select class="form-control select-input" id="lists" formControlName="lists">
                  <option value="0" hidden>Select List</option>
                  <option *ngFor="let list of _listsSelecListOptions" [ngValue]="list.value">
                    {{list.label}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <label for="listFields" class="input-label">Field</label>
                <select class="form-control select-input" id="listFields" formControlName="listFields">
                  <option value="0" hidden>Select Field</option>
                  <option *ngFor="let option of _listFieldsSelectListOptions" [ngValue]="option.value">
                    {{option.label}}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" mdbBtn color="secondary" class="waves-light btn-cancel-modal" aria-label="Close"
            (click)="insertWildcardModal.hide()">Close</button>
          <button type="submit" [disabled]="!_formGroupInsertWildcard.valid" mdbBtn color="primary"
            class="relative waves-light btn-insert-modal">Insert</button>
        </div>
      </form>
    </div>
  </div>
</div>
